import React from 'react';

import { CONDITIONS_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import { NAMING_CONVENTIONS_FIELDS } from '../../common/fields';
import SelectField from '../Controls/SelectField/SelectField';
import TextInput from '../Controls/TextInput/TextInput';

import styles from './CustomInsight.module.css';
import { SUBCATEGORIES } from '../../common/categories';

const { CONDITION, CONDITION_TYPE } = NAMING_CONVENTIONS_FIELDS;

const NamingConvention = ({ namingConvention, changedFunc, filteredOptions, disabled = false }) => {
    return (
        <div className={styles.namingConvention}>
            <SelectField
                field={namingConvention[CONDITION_TYPE.ID]}
                color="grey"
                changed={changedFunc}
                options={Object.values(CONDITIONS_OPTIONS).filter(
                    (opt) => !filteredOptions?.find((fopt) => fopt.value === opt.value)
                )}
                disabled={disabled}
                featureLockId={SUBCATEGORIES.NEW_AZURE_CONNECTORS.ID}
                featureLockIsTabId={true}
            />
            <TextInput
                field={namingConvention[CONDITION.ID]}
                color="grey"
                changed={changedFunc}
                disabled={disabled}
                featureLockId={SUBCATEGORIES.NEW_AZURE_CONNECTORS.ID}
                featureLockIsTabId={true}
            />
        </div>
    );
};

export default React.memo(NamingConvention);
